import { adminRoutes } from '@bettermode/domain/routes/web/admin'
import { T } from '@tribeplatform/react-components/i18n'
import { TemplateSidebar } from '@tribeplatform/react-components/Templates'
import { useRouter } from '@tribeplatform/react-sdk'
import { BackgroundProvider } from '@tribeplatform/react-ui-kit/BackgroundContext'
import { Container } from '@tribeplatform/react-ui-kit/Layout'
import { SectionHeader } from '@tribeplatform/react-ui-kit/SectionHeader'
import { Sidebar } from '@tribeplatform/react-ui-kit/Sidebar'

import { SidebarBackButton } from '../AdminMenu/SidebarBackButton.js'
import { Preview } from '../Editor/Preview/Preview.js'

export function CreateSpaceRoute() {
  return (
    <div className="flex h-full">
      <BackgroundProvider backgroundType="surface">
        <SidebarRoute />
      </BackgroundProvider>
      <div className="flex-1 overflow-hidden">
        <Preview />
      </div>
    </div>
  )
}

export function SidebarRoute() {
  return (
    <div className="flex h-full">
      <Sidebar size="lg" className="h-full">
        <Sidebar.Content className="flex flex-col gap-4">
          {/* href is the fallback when there's no in-app history (e.g. direct navigation) */}
          <SidebarBackButton
            href={adminRoutes.design.customizer.root}
            onClick={e => {
              if (window.history.state?.idx > 0) {
                e.preventDefault()
                window.history.back()
              }
            }}
          />
          <SectionHeader
            title={
              <T id="Generics.CreateSpace" defaultMessage="Create {SPACE_CC}" />
            }
          />
          <TemplateSidebar />
        </Sidebar.Content>
      </Sidebar>
      <div className="flex-1 overflow-hidden">
        <Container
          size="full"
          containerProps={{
            className: '@container h-full relative overflow-auto',
          }}
        >
          <Preview />
        </Container>
      </div>
    </div>
  )
}

export function CreateSpaceBreadCrumb() {
  const { Link } = useRouter()
  return (
    <Link
      href={adminRoutes.site.createSpace}
      className="flex items-center gap-1"
    >
      <T id="Generics.CreateSpace" defaultMessage="Create {SPACE_CC}" />
    </Link>
  )
}
